import PaymentService from '@/services/PaymentService.js'

export const actions = {
    addKeys({ dispatch }, keyPair) {
        return PaymentService.postKeys(keyPair)
            .then((response) => {
                const notification = {
                    type: 'success',
                    message: 'Your new keys has been added successfully!'
                }
                dispatch('notification/add', notification, { root: true })
                return response
            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: 'There was a problem adding your keys: ' + error.message
                }
                dispatch('notification/add', notification, { root: true })
                throw error
            })
    },
    getKeys({ dispatch }, productId) {
        return PaymentService.getKeys(productId)
            .then(response => {
                const notification = {
                    type: 'success',
                    message: 'Your keys has been fetched successfully!'
                }
                dispatch('notification/get', notification, { root: true })
                const decodedKey = Buffer.from(response.data.publishable_key, 'base64')
                var originalKey = decodedKey.toString();
                return originalKey
            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: 'There was a problem fetching your keys: ' + error.message
                }
                dispatch('notification/get', notification, { root: true })
                throw error
            })
    },
    getPaymentIntent({ dispatch }, productDetails) {
        return PaymentService.getPaymentIntent(productDetails.productId, productDetails.body)
            .then(response => {
                if (response.data.error) throw response.data.error
                else {
                    const notification = {
                        type: 'success',
                        message: 'Your intent has been created successfully!'
                    }
                    dispatch('notification/add', notification, { root: true })
                    return response.data
                }
            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: 'There was a problem creating your intent: ' + error
                }
                dispatch('notification/add', notification, { root: true })
                throw error
            })
    },
    getPaymentMethod({ dispatch }, paymentDetails) {
        return PaymentService.getPaymentMethod(paymentDetails.paymentMethodId, paymentDetails.cartId)
            .then(response => {
                const notification = {
                    type: 'success',
                    message: 'Your payment method has retrieved successfully!'
                }
                dispatch('notification/add', notification, { root: true })
                return response.data
            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: 'There was a problem getting your payment details: ' + error.message
                }
                dispatch('notification/add', notification, { root: true })
                throw error
            })
    },
    fetchAdminPublishableKey({ dispatch }) {
        return PaymentService.getAdminPublishableKey()
          .then(response => {
            const notification = {
              type: 'success',
              message: 'Your keys have been fetched!'
            }
            dispatch('notification/add', notification, { root: true })
            return response.data
          })
          .catch(error => {
            const notification = {
              type: 'error',
              message: 'There was a problem fetching your admin keys: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
          })
      },
}